module.exports = __webpack_public_path__ + "static/media/42_A.60678947.png";